import { render, staticRenderFns } from "./StreamsSchedule.vue?vue&type=template&id=4847a668"
import script from "./StreamsSchedule.vue?vue&type=script&lang=ts"
export * from "./StreamsSchedule.vue?vue&type=script&lang=ts"
import style0 from "./StreamsSchedule.vue?vue&type=style&index=0&id=4847a668&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports